import { ReactElement } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";

interface IProps {
  title: string;
  onAccept: () => void;
  onCancel: () => void;
  children: ReactElement | ReactElement[];
}
const ConfigDialog = ({ title, onAccept, children, onCancel }: IProps): ReactElement => {

  return (
    <Dialog onClose={onCancel} aria-labelledby="customized-dialog-title" open={true} maxWidth="md" keepMounted={true}>
      <DialogTitle id="customized-dialog-title">
        {title}
      </DialogTitle>
      <DialogContent dividers={true} >
        {children}
      </DialogContent>
      <DialogActions>
        <Button onClick={onAccept} variant="contained" color="primary" startIcon={<CheckIcon />}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfigDialog;
